<template>
  <customize-form :schema="schema" ref="form" />
</template>

<script>
import CustomizeForm from './customize-form'

export default {
  components: {
    CustomizeForm,
  },
  data() {
    return {
      schema: [
        {
          label: '产品名称',
          type: 'select',
          key: 'productName',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          selectList: [
            {
              id: 1,
              name: 'Quick Check',
            },
            {
              id: 2,
              name: 'Financial Standing',
            },
            {
              id: 3,
              name: 'Decision Support',
            },
          ],
        },
        {
          type: 'input',
          label: '邓白氏编码',
          key: 'dunsNumber',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
      ],
    }
  },
  created() {
    this._initFormDefaultValue()
  },
  methods: {
    _initFormDefaultValue() {
      this.schema.forEach((item, index) => {
        if (item.key === 'dunsNumber') {
          this.schema.splice(index, 1, {
            ...item,
            value: this.$route.query.dunsNumber,
          })
        }
      })
    },
    async validate() {
      const valid = await this.$refs.form.validateFields()
      if (valid) {
        const result = this.$refs.form.getFormData()
        if (result.country) {
          result.country = this.countryList.filter(
            item => item.id === result.country,
          )[0].mark
        }
        return result
      }
    },
  },
}
</script>
